import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";
import { useScriptMode } from "../../../../contexts/ScriptModeContext";
import { ACTIVITY_LABEL_KEYS } from "../../../goals/goalRules";
import { ICON_TRIGGER_CLASS } from "./PeriodSelect";

/** Seçenek yazısı: "Risale · Okuma". */
export function goalOptionText(option, t) {
  return `${option.label} · ${t(ACTIVITY_LABEL_KEYS[option.activity] || ACTIVITY_LABEL_KEYS.okuma)}`;
}

/**
 * Ortak hedef seçimi (PeriodSelect ile aynı düğme ve liste). İlk seçenek
 * "Tüm hedefler" (value null), ardından en az iki kardeşte olan hedefler.
 */
export default function GoalSelect({ options, value, onChange, disabled, variant = "pill" }) {
  const { t } = useScriptMode();
  const [anchor, setAnchor] = useState(null);
  const current = options.find((o) => o.key === value) || null;
  const items = [{ key: null, text: t("Tüm hedefler") }, ...options.map((o) => ({ key: o.key, text: goalOptionText(o, t) }))];

  return (
    <>
      {variant === "icon" ? (
        <button
          type="button"
          data-goal-trigger="icon"
          disabled={disabled}
          onClick={(e) => setAnchor(e.currentTarget)}
          aria-label={`${t("Hedef seç")}: ${current ? goalOptionText(current, t) : t("Tüm hedefler")}`}
          title={t("Hedef seç")}
          className={ICON_TRIGGER_CLASS}
        >
          <TrackChangesOutlinedIcon sx={{ fontSize: 18 }} aria-hidden />
        </button>
      ) : (
        <button
          type="button"
          data-goal-trigger
          disabled={disabled}
          onClick={(e) => setAnchor(e.currentTarget)}
          className="inline-flex items-center gap-1.5 h-9 max-w-[220px] px-3.5 rounded-full border border-terakkiBrandMist bg-terakkiSurface text-terakkiPrimaryDark text-sm font-medium disabled:opacity-50 dark:bg-white/10 dark:border-white/15 dark:text-white"
        >
          <FlagOutlinedIcon sx={{ fontSize: 16 }} aria-hidden />
          <span className="truncate">{current ? goalOptionText(current, t) : t("Tüm hedefler")}</span>
          <KeyboardArrowDownIcon sx={{ fontSize: 18 }} aria-hidden />
        </button>
      )}
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { borderRadius: 3, minWidth: 200 } } }}
      >
        {items.map((item) => {
          const selected = item.key === (current ? current.key : null);
          return (
            <MenuItem
              key={item.key || "all"}
              data-goal={item.key || "all"}
              selected={selected}
              onClick={() => {
                setAnchor(null);
                if (!selected) onChange(item.key);
              }}
              sx={{ justifyContent: "space-between", gap: 2, fontSize: 15 }}
            >
              {item.text}
              {selected ? <CheckIcon fontSize="small" /> : null}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
